import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CustomNumeral from '../../shared/customNumeral.component';
import DrillDetailLink from './drillDetailLink.component';
import { TOTAL_ROW, FUNC_CURRENCY_FIELD, TAX_CURRENCY_FIELD, US_FEDERAL_TOTAL } from './constants';
import { groupFieldSelector, detailAggregationSelector, countryTaxTypeToFilterSelector } from './store/selectors';
import { getCellElementToElevateSelector } from '../../scenarios/scenarioReport/utils';

const mapColumnFieldToReportLineType = columnField => ({
  PERMS: 'PERM_DIFF',
  TEMPS: 'TEMP_DIFF',
  B2T_PERM: 'PERM_DIFF',
  B2T_TEMP: 'TEMP_DIFF',
  G2S_PERM: 'G2S_NONREV_DIFF',
  G2S_TEMP: 'G2S_REV_DIFF',
  TOTAL_CR: 'CREDIT',
  DEF_PR_CR_UTL: 'DEF_CREDIT',
  GAAP_DEF_PR_CR_UTL: 'DEF_CREDIT',
})[columnField] || columnField;

class TaxExpenseTooltip extends PureComponent {
  static propTypes = {
    value: PropTypes.number,
    data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    colDef: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    node: PropTypes.shape({
      rowIndex: PropTypes.number.isRequired,
    }),
    column: PropTypes.shape({
      colId: PropTypes.string,
    }),

    groupField: PropTypes.string.isRequired,
    useHistorical: PropTypes.bool,
    detailAggregationType: PropTypes.string.isRequired,
    countryTaxType: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const {
      data,
      colDef,
      groupField,
    } = this.props;

    const { field: columnField } = colDef;

    this.isTotalRow = data.BUSINESS?.includes(TOTAL_ROW)
      || data.BUSINESS_UNIT?.includes(TOTAL_ROW)
      || data.COMPANY_CODE?.includes(TOTAL_ROW) || data.COMPANY_CODE === US_FEDERAL_TOTAL
      || data.COUNTRY_CODE?.includes(TOTAL_ROW)
      || data.LEGAL_ENTITY?.includes(TOTAL_ROW)
      || data.STATUS_NAME === null;

    this.columnTitle = colDef.headerName;
    this.reportLineType = mapColumnFieldToReportLineType(columnField);
    this.groupItem = data[groupField];
  }

  render() {
    const {
      data,
      useHistorical,
      node: {
        rowIndex,
      },
      column: {
        colId,
      },
    } = this.props;

    return this.isTotalRow
      ? (
        <CustomNumeral>{this.props.value}</CustomNumeral>
      )
      : (
        <DrillDetailLink
          useHistorical={!!useHistorical}
          reportLineType={this.reportLineType}
          groupItem={this.groupItem}
          columnTitle={this.columnTitle}
          funcCurrency={data[FUNC_CURRENCY_FIELD]}
          taxCurrency={data[TAX_CURRENCY_FIELD]}
          detailAggregationType={this.props.detailAggregationType}
          countryTaxType={this.props.countryTaxType}
          cellToElevateSelector={getCellElementToElevateSelector(colId, rowIndex)}
        >
          <CustomNumeral>{this.props.value}</CustomNumeral>
        </DrillDetailLink>
      );
  }
}

function mapStateToProps(state) {
  return {
    groupField: groupFieldSelector(state),
    detailAggregationType: detailAggregationSelector(state),
    countryTaxType: countryTaxTypeToFilterSelector(state),
  };
}

export default connect(mapStateToProps)(TaxExpenseTooltip);
